import { postRequest, patchJsonRequest, deleteRequest, getRequest } from '../../../core/utils/api';
import { type KeycloakContext } from '../../authentication/keycloak/KeycloakProvider';
import type FacilityDisplay from '../models/facility-display';

export interface CreateFacilityDisplayRequest {
  name: string;
  facilityId: string;
}

export interface UpdateFacilityDisplayRequest {
  name?: string;
  isPaused?: boolean;
  isPublic?: boolean;
}

export const createFacilityDisplay = async (
  request: CreateFacilityDisplayRequest,
  keycloak: KeycloakContext,
): Promise<FacilityDisplay | undefined> => {
  const apiResponse = await postRequest<FacilityDisplay>('facility-display', keycloak, request);
  return apiResponse.error ? undefined : apiResponse.json;
};

export const listFacilityDisplays = async (facilityId: string, keycloak: KeycloakContext): Promise<FacilityDisplay[] | undefined> => {
  const apiResponse = await getRequest<FacilityDisplay[]>(`facility-display?facilityId=${facilityId}`, keycloak);
  return apiResponse.error ? undefined : apiResponse.json;
};

export const updateFacilityDisplay = async (
  displayId: string,
  request: UpdateFacilityDisplayRequest,
  keycloak: KeycloakContext,
): Promise<FacilityDisplay | undefined> => {
  // The endpoint binds a command object, not an RFC 6902 patch document — send plain JSON.
  const apiResponse = await patchJsonRequest<FacilityDisplay>(`facility-display/${displayId}`, keycloak, request);
  return apiResponse.error ? undefined : apiResponse.json;
};

export const revokeFacilityDisplay = async (displayId: string, keycloak: KeycloakContext): Promise<FacilityDisplay | undefined> => {
  const apiResponse = await postRequest<FacilityDisplay>(`facility-display/${displayId}/revoke`, keycloak, {});
  return apiResponse.error ? undefined : apiResponse.json;
};

export const deleteFacilityDisplay = async (displayId: string, keycloak: KeycloakContext): Promise<boolean> => {
  const apiResponse = await deleteRequest<boolean>(`facility-display/${displayId}`, keycloak);
  return !apiResponse.error;
};

export const pairFacilityDisplay = async (
  displayId: string,
  pairingCode: string,
  keycloak: KeycloakContext,
): Promise<FacilityDisplay | undefined> => {
  const apiResponse = await postRequest<FacilityDisplay>('facility-display/pair', keycloak, { displayId, pairingCode });
  return apiResponse.error ? undefined : apiResponse.json;
};
